import { render, staticRenderFns } from "./overviewActionButton.vue?vue&type=template&id=534ceca6&scoped=true&"
import script from "./overviewActionButton.vue?vue&type=script&lang=js&"
export * from "./overviewActionButton.vue?vue&type=script&lang=js&"
import style0 from "./overviewActionButton.vue?vue&type=style&index=0&id=534ceca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ceca6",
  null
  
)

export default component.exports